import React from 'react'
import { Button } from '@drifthq/tide-core'
import office365Logo from 'images/office365.svg'

const MicrosoftOauth = ({ onConnectClick }) => {
  return <div className="setup-meetings-calendar" onClick={onConnectClick}>
    <img alt="" className="logo calendar-logo" src={office365Logo} />
    <label>Office 365</label>
    <Button
      type="primary"
      size="small"
    >
      Connect
    </Button>
  </div>
}

export default MicrosoftOauth



// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/MicrosoftOauth/component.js